import React, { useState } from 'react';
import logo from '../../assets/icons/hubofallthings-white.svg';
import { Routes, SandboxRoutes } from '../../app/AppRouter';
import './LandingPage.scss';
import { useSelector } from 'react-redux';
import { selectSandbox } from '../sandbox/sandboxSlice';
import HatPdaDialog from '../../components/shared/HatPdaDialog/HatPdaDialog';
import { SandboxHeader } from '../../components/SandboxHeader/SandboxHeader';
import { useDataswiftNotification } from '../../utils/customHooks';
import { useHistory } from 'react-router';

type Props = {
  default?: boolean;
  path?: string;
};

export const LandingPage: React.FC<Props> = () => {
  const [state, setState] = useState({ showDialog: false, open: false });
  const history = useHistory();
  const sandbox = useSelector(selectSandbox);
  const ribbon = useDataswiftNotification(true);

  const switchDialog = (dialogState: boolean) => {
    setState({ ...state, open: dialogState });
  };

  const navigateToSignup = () => {
    const navigateUri = sandbox ? SandboxRoutes.hatSignup : Routes.hatSignup;
    history.push(navigateUri + window.location.search);
  };

  const navigateToLogin = () => {
    const navigateUri = sandbox ? SandboxRoutes.hatLogin : Routes.hatLogin;
    history.push(navigateUri + window.location.search);
  };

  const onWhatsHatPdaClicked = () => {
    setState({ ...state, open: true });
  };

  return (
    <div>
      {sandbox && <SandboxHeader />}
      <div
        className={'landing-page'}
        style={sandbox ? { backgroundImage: 'none', backgroundColor: '#4a556b' } : undefined}
      >
        {ribbon}
        <div className={'landing-page-container'}>
          <div className={'landing-page-wrapper'}>
            <img src={logo} className={'landing-page-icon'} alt={'Hub of all things logo'} />
            {sandbox ? (
              <div className={'landing-page-sandbox-wrapper'}>
                <div className={'hatters-test'}>Test</div>
                <div className={'landing-page-title'}>Welcome to the HAT Testing Environment</div>
              </div>
            ) : (
              <div>
                <div className={'landing-page-title'}>Your own private space on the internet.</div>

                <div className={'landing-page-message'}>
                  Your personal data is precious. Get a HAT Personal Data Account (PDA) now to store your data and have
                  access to private AI.
                </div>
              </div>
            )}

            <div className="landing-page-user-actions">
              <button className="landing-page-btn landing-page-btn-signup" onClick={() => navigateToSignup()}>
                Create account
              </button>
              <button className="landing-page-btn landing-page-btn-transparent" onClick={() => navigateToLogin()}>
                Log in
              </button>
            </div>
          </div>

          <button
            className="landing-page-btn landing-page-btn-transparent-white"
            onClick={() => onWhatsHatPdaClicked()}
          >
            What is a HAT PDA?
          </button>

          <HatPdaDialog open={state.open} switchDialog={switchDialog} />
        </div>
      </div>
    </div>
  );
};
